import { gettext } from '@eventbrite/i18n';

export const PAYMENT_AND_SERVICE_FEE = {
    com: {
        service_fee: gettext('3.7% + $1.79 service fee per ticket'),
        payment_fee: gettext('2.9% payment processing fee per order'),
        link: 'https://www.eventbrite.com/help/en-us/articles/755615/',
    },
    ca: {
        service_fee: gettext('3.5% + C$1.29 service fee per ticket'),
        payment_fee: gettext('2.9% payment processing fee per order'),
        link: 'https://www.eventbrite.ca/help/en-ca/articles/755615/',
    },
    uk: {
        service_fee: gettext('6.95% + £0.59 service fee per ticket'),
        payment_fee: gettext(''),
        link: 'https://www.eventbrite.co.uk/help/en-gb/articles/755615/',
    },
    ie: {
        service_fee: gettext('5.9% + €0.79 service fee per ticket'),
        payment_fee: gettext(''),
        link: 'https://www.eventbrite.ie/help/en-ie/articles/755615/',
    },
    au: {
        service_fee: gettext('5.35% + A$1.19 service fee per ticket'),
        payment_fee: gettext(''),
        link: 'https://www.eventbrite.com.au/help/en-au/articles/755615/',
    },
    nz: {
        service_fee: gettext('4.2% + NZ$0.55 service fee per ticket;'),
        payment_fee: gettext('2.4% payment processing fee per order'),
        link: 'https://www.eventbrite.com/help/en-us/articles/755615/',
    },
};

export const SEND_MORE_EMAILS = {
    com: {
        starting_price: gettext('Starting at $15/month'),
        learn_more_cta: 'https://www.eventbrite.com/l/email-marketing/',
    },
    ca: {
        starting_price: gettext('Starting at CAN $21/month'),
        learn_more_cta: 'https://www.eventbrite.ca/l/email-marketing/',
    },
    uk: {
        starting_price: gettext('Starting at £12/month'),
        learn_more_cta: 'https://www.eventbrite.co.uk/l/email-marketing/',
    },
    ie: {
        starting_price: gettext('Starting at €14/month'),
        learn_more_cta: 'https://www.eventbrite.ie/l/email-marketing/',
    },
    au: {
        starting_price: gettext('Starting at AUD $15/month'),
        learn_more_cta: 'https://www.eventbrite.com.au/l/email-marketing/',
    },
    nz: {
        starting_price: gettext('NZ $15/month'),
        learn_more_cta: 'https://www.eventbrite.nz/l/email-marketing/',
    },
};

export const EB_ADS = {
    com: 'https://www.eventbrite.com/l/eventbrite-ads/',
    ca: 'https://www.eventbrite.ca/l/eventbrite-ads/',
    uk: 'https://www.eventbrite.co.uk/l/eventbrite-ads/',
    au: 'https://www.eventbrite.com.au/l/eventbrite-ads/',
    ie: '',
    nz: '',
};
